import { Module } from 'vuex';
import { LoginFailureRecordState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;

export const state: LoginFailureRecordState = {
    loginFailureRecords: undefined,
    loginFailureRecordCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

export const loginFailureRecord: Module<LoginFailureRecordState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
